import useAffiliatesFAQTopic from '@/hooks/theme/variants/Affiliates/useAffiliatesFAQTopic';
import { SettingLayoutComponentId } from '@starsoft/common/models';
import { FaqTopicIconProps } from './props';
import dynamic from 'next/dynamic';

const FaqTopicIconV1 = dynamic(() => import('./V1'), { ssr: false });
const FaqTopicIconV2 = dynamic(() => import('./V2'), { ssr: false });

export default function FaqTopicIcon({ isOpen }: FaqTopicIconProps) {
  const { version } = useAffiliatesFAQTopic();

  switch (version?.toString()) {
    case SettingLayoutComponentId.AffiliatesFAQTopicV1?.toString():
      return <FaqTopicIconV1 />;
    case SettingLayoutComponentId.AffiliatesFAQTopicV2?.toString():
      return <FaqTopicIconV2 isOpen={isOpen} />;
    default:
      return <FaqTopicIconV1 />;
  }
}
